import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMarketplaceListingById,
  selectSelectedMarketplaceListing,
} from '../../../../services/store/modules/marketplace';
import { MarketplaceListingItem } from '../../../../services/store/modules/marketplace/models';

const useSelectedListing = (
  id: string,
): [MarketplaceListingItem | undefined, boolean, string | undefined] => {
  const dispatch = useDispatch();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const selectedListing = useSelector(selectSelectedMarketplaceListing);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await dispatch(fetchMarketplaceListingById(id));
      } catch (e: unknown) {
        setError(
          'Something has gone wrong loading our listing. Please try again soon',
        );
      }
      setLoading(false);
    };
    fetchData();
  }, [dispatch, setLoading, id]);

  return [selectedListing, loading, error];
};

export default useSelectedListing;
